import { EntityBase } from '@/bases';

export class ItemsGroupedByItemDescription extends EntityBase {
  public SuperCallNumber: string = null;
  public ItemDescription: string = null;
  public Quantity: number = null;
  public HasNonVulcanInterimItem: boolean = false;
  public HasVulcanInterimItem: boolean = false;
  public HasNonVulcanThoroughItem: boolean = false;
  public HasVulcanThoroughItem: boolean = false;
  public ServiceEngineerRequired: boolean = false;
  public SupplementaryTestRequired: boolean = false;

  constructor(data: any = null) {
    super();
    this.Assign(data);
  }

  public toJSON(): any {
    return {};
  }
}